import './App.scss';
import leftArrow from './img/left.png'
import leftArrowHover from './img/left-hover.png'
import rightArrow from './img/right.png'
import rightArrowHover from './img/right-hover.png'
import reload from './img/reload.png'
import reloadHover from './img/reload-hover.png'
import fullscreen from './img/fullscreen.png'
import fullscreenHover from './img/fullscreen-hover.png'
import exitfullscreen from './img/exitfullscreen.png'
import exitfullscreenHover from './img/exitfullscreen-hover.png'

import React from "react";
import { useRef } from 'react';
import { Route, NavLink, Router, Switch, Redirect } from "react-router-dom";

import HoverImage from "react-hover-image"

import { createBrowserHistory } from 'history';
import screenfull from 'screenfull'

import { slide as Menu } from 'react-burger-menu'
import {LanguageContext} from "./LanguageContext"

import Info from "./Info"
import PoemInfo from "./PoemInfo"
import PoemTitle from "./PoemTitle"

import Huge from "./Huge";
import BookTitle from "./BookTitle";
import Rotate from "./Rotate"
import Beginning from "./Beginning"
import Wittgenstein from "./Wittgenstein"
import AllPoems from "./AllPoems"
import Complexity from "./Complexity"
import XYPoem from "./XYPoem"
import Entropy from "./Entropy"
import Proverbs from "./Proverbs"
import Left from "./Left"
import Eruption from "./Eruption"
import Cellular from "./Cellular"
import WaveFunctionCollapse from "./WaveFunctionCollapse"
import Now from "./Now"
import Spiral from "./Spiral"
import Birds from "./Birds"
import Walk from "./Walk"
import BlackWhite from "./BlackWhite"
import CircleM from "./CircleM"
import Imagine from "./Imagine"
import Un from "./Un"
import AProgrammer from "./AProgrammer"

const extensions = require("./extensions")

const menuContent = [
    {en: "title", de: "title", route: "/infinitytexts/"},
    {en: "a beginning", de: "ein anfang", route: "/infinitytexts/beginning"},
    {en: "rotation", de: "rotation", route: "/infinitytexts/rotate"},
    {en: "all possible poems", de: "alle möglichen gedichte", route: "/infinitytexts/allpoems"},
    {en: "grow", de: "wachsen", route: "/infinitytexts/huge"},
    {en: null, de: "ungewissheit", route: "/infinitytexts/wittgenstein"},
    {en: "complexity", de: "komplexität", route: "/infinitytexts/complexity"},
    {en: "xy", de: "xy", route: "/infinitytexts/xy"},
    {en: "proverbs", de: "sprichwörter", route: "/infinitytexts/proverbs"},
    {en: "left", de: "link", route: "/infinitytexts/left"},
    {en: "eruption", de: "eruption", route: "/infinitytexts/eruption"},
    {en: "wave function", de: "wellenfunktion", route: "/infinitytexts/wfc"},
    {en: "imagine", de: "stell dir vor", route: "/infinitytexts/imagine"},
    {en: "present", de: "gegenwart", route: "/infinitytexts/now"},
    {en: "spiral", de: "spirale", route: "/infinitytexts/spiral"},
    {en: "birds", de: "vögel", route: "/infinitytexts/birds"},
    {en: "cellular automaton", de: "zellulärer automat", route: "/infinitytexts/cellular"},
    {en: "walk", de: "gehen", route: "/infinitytexts/walk"},
    {en: "blackwhite", de: "schwarzweiss", route: "/infinitytexts/blackwhite"},
    {en: "m", de: "m", route: "/infinitytexts/circlem"},
    {en: "un", de: "un", route: "/infinitytexts/un"},
    {en: "entropy", de: "entropie", route: "/infinitytexts/entropy"},
    {en: "a programmer", de: "eine programmiererin", route: "/infinitytexts/aprogrammer"}
]

function FullscreenToggleButton(props) {
    const imageRef = useRef();

    function setFullscreenButtonSrc(src) {
        if (imageRef.current !== null && imageRef.current !== undefined) {
            imageRef.current.src = src
        }
    }

    if (props.fullscreen) {
        return (
            <button className="controlButton largeControlButton" onClick={() => screenfull.exit()}>
                <img ref={imageRef} src={exitfullscreen} onMouseOver={() => setFullscreenButtonSrc(exitfullscreenHover)} onMouseOut={() => setFullscreenButtonSrc(exitfullscreen)} alt="Exit Fullscreen" style={{width:30}} id="fullscreenImg"/>
            </button>
        )
    }
    else {
        return (
            <button className="controlButton largeControlButton" onClick={() => screenfull.request()}>
                <img ref={imageRef} src={fullscreen} onMouseOver={() => setFullscreenButtonSrc(fullscreenHover)} onMouseOut={() => setFullscreenButtonSrc(fullscreen)} alt="Enter Fullscreen" style={{width:30}} id="fullscreenImg"/>
            </button>
        )
    }
}

class App extends React.Component {
    constructor(props) {
        super(props)

        this.menuContent = menuContent

        this.goLeft = this.goLeft.bind(this);
        this.goRight = this.goRight.bind(this);
        this.reload = this.reload.bind(this);
        this.changePoemInfo = this.changePoemInfo.bind(this)
        this.closeMenu = this.closeMenu.bind(this)
        this.onSelectPoem = this.onSelectPoem.bind(this)
        this.toggleLanguage = this.toggleLanguage.bind(this)
        this.setLanguage = this.setLanguage.bind(this)
        this.onChangeFullscreen = this.onChangeFullscreen.bind(this)

        this.state = {fullscreen: false, showMenu: false, poemInfo: {}, currentLanguage: localStorage.getItem('language') || "en", toggleLanguage: this.toggleLanguage}

        this.history = createBrowserHistory()

        if (screenfull.isEnabled) {
	        screenfull.on('change', () => {
		        console.log('Am I fullscreen?', screenfull.isFullscreen ? 'Yes' : 'No');
                this.onChangeFullscreen()
	        });
        }
    }

    setLanguage(newLanguage) {
        this.setState({
            currentLanguage: newLanguage
        },() => {
            localStorage.setItem('language', newLanguage)
        })
    }

    toggleLanguage() {
        let newLanguage = this.state.currentLanguage === "en" ? "de" : "en"
        this.setLanguage(newLanguage)
    }

    closeMenu() {
        this.setState({showMenu: false})
    }

    handleStateChange (state) {
        this.setState({showMenu: state.isOpen})
    }

    onSelectPoem() {
        this.closeMenu()
    }

    changePoemInfo(strings) {
        this.setState({poemInfo: strings})
        extensions.scrollToTop()
        this.closeMenu()
    }

    findCurrentRouteNr() {
        let index = 0

        for (var menuEntry of menuContent) {
            if (menuEntry.route === window.location.pathname) {
                return index
            }
            index++
        }
        return null
    }

    goToNr(nr) {
        this.history.push(menuContent[nr].route)
        return menuContent[nr][this.state.currentLanguage] !== null
    }

    goLeft() {
        let routeNr = this.findCurrentRouteNr()

        if (routeNr === null) {
            routeNr = 0
        }
        else {
            routeNr--
            if (routeNr < 0) {
                routeNr = menuContent.length-1
            }
        }
        if (!this.goToNr(routeNr)) {
            this.goLeft()
        }
    }

    goRight() {
        let routeNr = this.findCurrentRouteNr()

        if (routeNr === null) {
            routeNr = 0
        }
        else {
            routeNr++
            if (routeNr >= menuContent.length) {
                routeNr = 0
            }
        }
        if (!this.goToNr(routeNr)) {
            this.goRight()
        }
    }

    reload() {
        window.location.reload();
    }

    navigation(fs) {
        return <div className="navigation">
            <button className="controlButton largeControlButton" onClick={this.goLeft}>
                <HoverImage src={leftArrow} hoverSrc={leftArrowHover} alt="Left" style={{width:30}}/>
            </button>
            <button className="controlButton largeControlButton" onClick={this.reload}>
                <HoverImage src={reload} hoverSrc={reloadHover} alt="Reload" style={{width:30}}/>
            </button>
            {screenfull.isEnabled &&
                <FullscreenToggleButton fullscreen={fs} />
            }

            <Info />

            <PoemInfo info={this.state.poemInfo} />
            <button className="controlButton largeControlButton" onClick={this.goRight}>
                <HoverImage src={rightArrow} hoverSrc={rightArrowHover} alt="Right" style={{width:30}}/>
            </button>
        </div>
    }

    onChangeFullscreen() {
        setTimeout(() => {
            this.setState({fullscreen: screenfull.isFullscreen})
        }, 10)
    }

    render() {
        const fs = this.state.fullscreen

        return (
            <Router history={this.history}>
                    <div className="App">
                        <PoemTitle title={this.state.poemInfo.title}/>
                        <LanguageContext.Provider value={{language:this.state.currentLanguage, toggleLanguage: this.state.toggleLanguage}}>
                            {this.navigation(fs)}
                            <Menu
                            disableAutoFocus
                            isOpen={this.state.showMenu}
                            onStateChange={(state) => this.handleStateChange(state)}
                            width={280}
                            >
                                {this.menuContent.map((content, index) => {
                                    var title = content[this.state.currentLanguage]

                                    if (title === null) {
                                        return null
                                    }
                                    else {
                                        return <NavLink key={index} to={content.route} onClick={() => this.onSelectPoem()}>{title}</NavLink>
                                    }
                                })
                                }
                            </Menu>
                            <Switch>
                                <Route exact path="/infinitytexts/">
                                    <BookTitle
                                    onchangePoemInfo={this.changePoemInfo}
                                    onSetLanguage={this.setLanguage}
                                    fullscreenEnabled={screenfull.isEnabled}
                                    isFullscreen={fs}
                                    toggleFullscreen={() => screenfull.toggle()}/>
                                </Route>
                                <Route path="/infinitytexts/rotate">
                                    <Rotate onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/huge">
                                    <Huge onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/beginning">
                                    <Beginning onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/wittgenstein">
                                    <Wittgenstein onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/allpoems">
                                    <AllPoems onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/complexity">
                                    <Complexity language={this.state.currentLanguage} onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/xy">
                                    <XYPoem onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/entropy">
                                    <Entropy onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/proverbs">
                                    <Proverbs language={this.state.currentLanguage} onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/left">
                                    <Left onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/eruption">
                                    <Eruption language={this.state.currentLanguage} onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/cellular">
                                    <Cellular language={this.state.currentLanguage} onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/wfc">
                                    <WaveFunctionCollapse language={this.state.currentLanguage} onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/now">
                                    <Now onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/spiral">
                                    <Spiral language={this.state.currentLanguage} onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/birds">
                                    <Birds onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/walk">
                                    <Walk onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/blackwhite">
                                    <BlackWhite onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/circlem">
                                    <CircleM onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/imagine">
                                    <Imagine language={this.state.currentLanguage} onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/un">
                                    <Un onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Route path="/infinitytexts/aprogrammer">
                                    <AProgrammer onchangePoemInfo={this.changePoemInfo} />
                                </Route>
                                <Redirect to="/infinitytexts/" />
                            </Switch>
                        </LanguageContext.Provider>
                    </div>
            </Router>
        );
    }
}


export default App;
